import React, { useState } from 'react';
import { localePath } from '../config/region';
import { API_URLS } from '../config/api';
import { apiPost } from '../utils/apiUtils';
import { t } from '../i18n';
import './AuthorOfferModal.css';

// Blocking modal shown to creators who haven't accepted the current author offer (оферта).
// On confirm it records acceptance server-side, then calls onAccepted so the page proceeds.
const AuthorOfferModal = ({ onAccepted }) => {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!agreed || loading) return;
    setLoading(true);
    try {
      await apiPost(API_URLS.AUTHOR_OFFER_ACCEPT, {}, {}, true, t('Согласие сохранено'));
      onAccepted();
    } catch {
      // Error already shown by toast
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aom-overlay">
      <div className="aom-modal">
        <h2 className="aom-title">{t('Согласие с офертой автора')}</h2>
        <p className="aom-text">
          {t('Чтобы продолжить работу в конструкторе новелл, подтвердите согласие с условиями оферты для авторов.')}
        </p>
        <label className="aom-check">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            disabled={loading}
          />
          <span>
            {t('Я согласен с условиями')}{' '}
            <a href={localePath('/author-offer')} target="_blank" rel="noopener noreferrer" className="aom-link">
              {t('оферты')}
            </a>
          </span>
        </label>
        <div className="aom-actions">
          <button
            type="button"
            className="aom-btn-primary"
            disabled={!agreed || loading}
            onClick={handleConfirm}
          >
            {loading ? t('Сохранение…') : t('Подтвердить')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthorOfferModal;
